// -------------------------------------
// Navlink Active
// -------------------------------------
(function($) {

  $(document).ready(function() {

    $(".nav-link").click(function() {
      if ($(this).hasClass("dropdown-toggle")) {
        // Do nothing
      } else {
        $(".nav-link").removeClass("active").addClass("not-active");
        $(this).removeClass("not-active").addClass("active");
      }

    });

  });

})(jQuery);
